import React, { useEffect } from 'react';
import { Route, useLocation, useHistory } from 'react-router-dom';
import {
  Login,
  Register,
  ForgotPassword,
  VerifyEmail,
  ChangePassword,
  VerifyUser,
} from '../../views/auth';

const AuthLayout = () => {
  const { pathname } = useLocation();
  const { push } = useHistory();

  useEffect(() => {
    const authPaths = [
      '/register',
      '/',
      '/forgot-password',
      '/verify-email',
      '/change-password',
      '/verify-user',
    ];
    if (!authPaths.includes(pathname)) {
      push('/');
    }
  }, [pathname, push]);

  return (
    <>
      <Route exact path="/" component={Login} />
      <Route exact path="/register" component={Register} />
      <Route exact path="/forgot-password" component={ForgotPassword} />
      <Route exact path="/verify-email" component={VerifyEmail} />
      <Route exact path="/change-password" component={ChangePassword} />
      <Route exact path="/verify-user" component={VerifyUser} />
    </>
  );
};

export default AuthLayout;
